import React, { createContext, useState } from "react";

export const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [subject, setSubject] = useState("");
  const [level, setLevel] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const [paymentMethod, setPaymentMethod] = useState([]); // updated to array
  const [price, setPrice] = useState([15, 100]); // 💰 Add price range
  const [isOnline, setIsOnline] = useState(-1); // 🛰️ -1 = both, 0 = in-person, 1 = online

  return (
    <FilterContext.Provider
      value={{
        selectedFilters,
        setSelectedFilters,
        subject,
        setSubject,
        level,
        setLevel,
        searchLocation,
        setSearchLocation,
        paymentMethod,
        setPaymentMethod,
        price,
        setPrice,
        isOnline,
        setIsOnline,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};
